/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import { Injectable } from '@angular/core';
import {OneSignal} from "@ionic-native/onesignal";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {FirebaseApp} from "angularfire2";
import {DataReference} from "../../shared/DataReference";
import {Device} from "@ionic-native/device";
import * as moment from 'moment';
import {appVersion} from "../../environments/firebase.config";

@Injectable()
export class DeviceUtilityService {

  static readonly UNKNOWN_TOKEN: string = 'UNKNOWN_TOKEN';

  private _pushToken$ = new BehaviorSubject<string>(null);
  private _uuid$ = new BehaviorSubject<string>(null);

  pushToken$ = this._pushToken$.asObservable();
  uuid$ = this._uuid$.asObservable();

  constructor(private oneSignal: OneSignal,
              private device: Device,
              private firebase: FirebaseApp) {
    console.log('Hello DeviceUtilityService Provider');
  }

  initForUser(userId: string) {
    if (userId) {
      this.handlePushToken(userId);
      this.handleUuid(userId);
    }
  }

  private handlePushToken(userId: string) {
    this.getPushToken(userId).then(token => {
      console.log('Checked token for user');
      if (token) {
        this._pushToken$.next(token);
        if (token != DeviceUtilityService.UNKNOWN_TOKEN) {
          this.firebase.database().ref(DataReference.getUserPushTokenRef(userId)).update(token, err => {
            if (err) {
              console.error('Error saving push token');
            } else {
              console.log('Updated user token');
            }
          });
        }
      } else {
        console.warn('No token to publish');
        // this._pushToken$.next('HI_ANDREA');
      }
    });
  }

  private handleUuid(userId: string) {
    const uuid = this.device.uuid;
    console.log('UUID: ' + uuid);

    if (uuid) {
      let data = {};
      data[DataReference.getUserUuidRef(userId)] = uuid;

      let device: any = {};
      device['lastLogin'] = moment().toISOString();
      device['model'] = this.device.model;
      device['version'] = this.device.version;
      device['cordova'] = this.device.cordova;
      device['platform'] = this.device.platform;
      device['appVersion'] = appVersion; // NOTE: Need to update the env variable

      data[`${DataReference.getUserDevicesRef(userId)}/${uuid}`] = device;

      this.firebase.database().ref().update(data, err => {
        if (err) {
          console.error('Error saving uuid');
        } else {
          console.log('Updated uuid');
          this._uuid$.next(uuid);
        }
      });
    } else {
      console.log('No uuid to publish');
    }
  }

  getPushToken(userId: string) : Promise<string> {
    return new Promise((resolve) => {
      this.oneSignal.getIds().then(ids => {
        if (ids) {
          resolve(ids.userId);
        } else {
          resolve(DeviceUtilityService.UNKNOWN_TOKEN);
        }
      }, err => {
        console.error(err);
        resolve(DeviceUtilityService.UNKNOWN_TOKEN);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/device-utility-service/device-utility-service.ts